import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 22c-.18 0-.36-.05-.51-.14a48 48 0 0 1-4.48-3.06C5.36 17.53.38 13.68 1.06 8.37a6.24 6.24 0 0 1 2.76-4.38c1.45-.96 3.14-1.23 4.76-.77.01 0 .11.04.13.04 1.25.39 2.36 1.21 3.29 2.46.94-1.25 2.05-2.08 3.32-2.46l.1-.03c1.61-.46 3.3-.19 4.74.76 1.53 1 2.54 2.6 2.77 4.39.69 5.31-4.3 9.16-5.94 10.43-1.42 1.1-2.92 2.13-4.48 3.06-.16.09-.34.14-.51.14zM7.05 5c-.73 0-1.46.22-2.12.66a4.3 4.3 0 0 0-1.88 2.97c-.37 2.84 1.28 5.57 5.18 8.59 1.2.93 2.47 1.81 3.77 2.62 1.31-.81 2.58-1.69 3.77-2.62 3.9-3.02 5.54-5.74 5.18-8.59a4.3 4.3 0 0 0-1.89-2.98c-.95-.62-2.04-.8-3.09-.51-1.23.38-2.25 1.35-3.08 2.91-.35.65-1.41.65-1.76 0-.83-1.55-1.85-2.53-3.02-2.89l-.1-.03C7.7 5.04 7.38 5 7.06 5z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }